export default __webpack_public_path__ + "static/media/portfolio-118.d59b49d0.jpg";